import React, { useState } from 'react';
import { Tabs } from 'antd';
import UploadPeopleManagerBudget from './UploadPeopleManagerBudget';
import UploadUnitManagerBudget from './UploadUnitManagerBudget';
import UploadUnitManagerBudgetMonthly from './UploadUnitManagerBudgetMonthly';
import UploadPointsForAllUsers from './UploadPointsForAllUsers';
import MainBudgetAdminPanel from './MainBudgetAdminPanel';
import ManagerBudgetAdminPanel from './ManagerBudgetAdminPanel';
import UnitBudgetAdminPanel from './UnitBudgetAdminPanel';

const BudgetPage: React.FC = () => {
  const [activeKey, setActiveKey] = useState('1');

  const onTabChange = (key: string) => {
    setActiveKey(key);
  };
  return (
    <Tabs activeKey={activeKey} onChange={onTabChange}>
      <Tabs.TabPane tab="Main Budget (Admin)" key="1">
        <MainBudgetAdminPanel />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Manager Budget (Admin)" key="2">
        <ManagerBudgetAdminPanel />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Unit Budget (Admin)" key="3">
        <UnitBudgetAdminPanel />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Upload People Manager Budget" key="4">
        <UploadPeopleManagerBudget />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Upload Unit Manager Budget (Manual)" key="5">
        <UploadUnitManagerBudget />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Upload Unit Manager Budget (Monthly upload)" key="6">
        <UploadUnitManagerBudgetMonthly />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Upload Points" key="7">
        <UploadPointsForAllUsers />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default BudgetPage;